export default __webpack_public_path__ + "static/media/image.seekbit.c5c819aa.png";